(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define('react-navbar',["react", "moment"], factory);
	else if(typeof exports === 'object')
		exports["ReactNavbar"] = factory(require("react"), require("moment"));
	else
		root["ReactNavbar"] = factory(root["react"], root["moment"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_25__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navbar = __webpack_require__(1);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _g2m = __webpack_require__(21);
	
	var _g2m2 = _interopRequireDefault(_g2m);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Navbar2.default.configureG2m = _g2m2.default;
	exports.default = _Navbar2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Logo = __webpack_require__(4);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Message = __webpack_require__(9);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _TopMenu = __webpack_require__(10);
	
	var _TopMenu2 = _interopRequireDefault(_TopMenu);
	
	var _Profile = __webpack_require__(12);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _ProfileMobile = __webpack_require__(13);
	
	var _ProfileMobile2 = _interopRequireDefault(_ProfileMobile);
	
	var _SignInLink = __webpack_require__(14);
	
	var _SignInLink2 = _interopRequireDefault(_SignInLink);
	
	var _SideMenu = __webpack_require__(15);
	
	var _SideMenu2 = _interopRequireDefault(_SideMenu);
	
	var _ProgressBar = __webpack_require__(18);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navbar = function (_React$Component) {
	  _inherits(Navbar, _React$Component);
	
	  function Navbar(props) {
	    _classCallCheck(this, Navbar);
	
	    var _this = _possibleConstructorReturn(this, (Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call(this, props));
	
	    _this.state = {
	      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1024,
	      showSideMenu: false
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.showSideMenu = _this.showSideMenu.bind(_this);
	    _this.hideSideMenu = _this.hideSideMenu.bind(_this);
	    return _this;
	  }
	
	  _createClass(Navbar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleResize();
	      window.addEventListener('resize', this.handleResize);
	      window.addEventListener('click', this.hideSideMenu);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	      window.addEventListener('click', this.hideSideMenu);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      var mediumScreen = 768;
	      var smallScreen = 650;
	      var body = document.getElementsByTagName('body')[0];
	
	      this.setState({
	        isSmallScreen: window.innerWidth <= smallScreen,
	        isMediumScreen: window.innerWidth > smallScreen && window.innerWidth <= mediumScreen,
	        isBigScreen: window.innerWidth > mediumScreen,
	        originalBodyOverflow: body.style.overflowY
	      });
	    }
	  }, {
	    key: 'showSideMenu',
	    value: function showSideMenu(event) {
	      if (this.props.onShowMenu) {
	        this.props.onShowMenu();
	      }
	
	      if (this.props.onMenuClicked) {
	        this.props.onMenuClicked();
	      }
	
	      this.setState({ showSideMenu: true });
	
	      if (event) {
	        event.preventDefault();
	        event.stopPropagation();
	      }
	
	      // we need to prevent scrolling of the body when
	      // we are in 'phone' size, otherwise you could
	      // interact/scroll the page grabing the navbar
	      if (this.state.isSmallScreen) {
	        var body = document.getElementsByTagName('body')[0];
	        body.style.overflowY = 'hidden';
	      }
	    }
	  }, {
	    key: 'hideSideMenu',
	    value: function hideSideMenu(event) {
	      this.setState({ showSideMenu: false });
	
	      if (event) {
	        event.stopPropagation();
	      }
	
	      if (this.state.isSmallScreen) {
	        var body = document.getElementsByTagName('body')[0];
	        body.style.overflowY = this.state.originalBodyOverflow;
	      }
	    }
	
	    // Use this helper function to pre-process menu item before usage
	
	  }, {
	    key: 'processMenuItemGroups',
	    value: function processMenuItemGroups(itemGroups) {
	      var _this2 = this;
	
	      // Attach hideSideMenu to the item onClick function
	      var attachOnClick = function attachOnClick(item) {
	        item = _extends({}, item);
	
	        var originalOnClick = item.onClick || function () {};
	
	        item.onClick = function (event) {
	          originalOnClick(event);
	          _this2.hideSideMenu(event);
	        };
	
	        return item;
	      };
	
	      return itemGroups.map(function (itemGroup) {
	        return itemGroup.map(function (item) {
	          return attachOnClick(item);
	        });
	      });
	    }
	  }, {
	    key: 'renderLogo',
	    value: function renderLogo() {
	      var logoElement = void 0;
	
	      if (this.props.logo && this.props.logo.imageSrc) {
	        logoElement = _react2.default.createElement(_Logo2.default, this.props.logo);
	      }
	
	      return logoElement;
	    }
	  }, {
	    key: 'renderTopMenu',
	    value: function renderTopMenu() {
	      // for phones do not show the top menu
	      if (this.state.isSmallScreen) {
	        return null;
	      }
	
	      var itemGroups = this.processMenuItemGroups(this.props.menu);
	
	      var items = itemGroups.reduce(function (acc, sub) {
	        return acc.concat(sub.filter(function (m) {
	          return m.isTopMenuItem;
	        }));
	      }, []);
	
	      return _react2.default.createElement(_TopMenu2.default, { menu: items });
	    }
	  }, {
	    key: 'renderMessage',
	    value: function renderMessage() {
	      // for phones do not show the alert message
	      if (!this.state.isBigScreen) {
	        return null;
	      }
	
	      var messageElement = void 0;
	
	      if (this.props.message && this.props.message.text) {
	        messageElement = _react2.default.createElement(_Message2.default, this.props.message);
	      }
	
	      return messageElement;
	    }
	  }, {
	    key: 'renderProfile',
	    value: function renderProfile() {
	      var handleClick = void 0;
	
	      if (!this.state.showSideMenu) {
	        handleClick = this.showSideMenu;
	      }
	
	      if (this.props.profile.isSignedIn) {
	        if (!this.state.isSmallScreen) {
	          return _react2.default.createElement(_Profile2.default, {
	            text: this.props.profile.name,
	            onClick: handleClick,
	            disabledJsHint: this.props.profile.disabledJsHint
	          });
	        } else {
	          return _react2.default.createElement(_ProfileMobile2.default, {
	            onClick: handleClick
	          });
	        }
	      } else {
	        return _react2.default.createElement(_SignInLink2.default, {
	          text: this.props.profile.signInText,
	          url: this.props.profile.signInUrl,
	          onClick: this.props.profile.onSignInClick
	        });
	      }
	    }
	  }, {
	    key: 'renderSideMenu',
	    value: function renderSideMenu() {
	      // Always leave in the DOM for animiation support.
	      // Instead, pass a prop and let the child component handle visibility.
	      var itemGroups = this.processMenuItemGroups(this.props.menu);
	
	      if (!this.state.isSmallScreen) {
	        itemGroups = itemGroups.map(function (itemGroup) {
	          return itemGroup.filter(function (item) {
	            return !item.isTopMenuItem;
	          });
	        });
	      }
	
	      return _react2.default.createElement(_SideMenu2.default, {
	        isActive: this.state.showSideMenu,
	        itemGroups: itemGroups,
	        isSmallScreen: this.state.isSmallScreen,
	        isProgressVisible: !!this.renderProgressBar()
	      });
	    }
	  }, {
	    key: 'renderProgressBar',
	    value: function renderProgressBar() {
	      if (this.props.progress.isProgressVisible && this.state.isBigScreen) {
	        return _react2.default.createElement(_ProgressBar2.default, {
	          onProgressClick: this.props.progress.onProgressClick,
	          percentage: this.props.progress.percentage,
	          isSelected: this.props.progress.isSelected
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var classNames = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, _styles2.default.navbar, true), _defineProperty(_classnames, _styles2.default.progressVisible, !!this.renderProgressBar()), _classnames));
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames, style: this.props.style },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.contentWrapper },
	          this.renderLogo(),
	          this.renderTopMenu(),
	          this.renderProgressBar(),
	          this.renderProfile(),
	          this.renderMessage()
	        ),
	        this.renderSideMenu()
	      );
	    }
	  }]);
	
	  return Navbar;
	}(_react2.default.Component);
	
	exports.default = Navbar;
	;
	
	Navbar.propTypes = {
	  logo: _react2.default.PropTypes.shape({
	    imageSrc: _react2.default.PropTypes.string.isRequired,
	    url: _react2.default.PropTypes.string,
	    altText: _react2.default.PropTypes.string
	  }),
	
	  message: _react2.default.PropTypes.shape({
	    text: _react2.default.PropTypes.string.isRequired,
	    messageAction: _react2.default.PropTypes.func,
	    buttonText: _react2.default.PropTypes.string
	  }),
	
	  profile: _react2.default.PropTypes.shape({
	    isSignedIn: _react2.default.PropTypes.bool,
	    name: _react2.default.PropTypes.string,
	    signInText: _react2.default.PropTypes.string,
	    signInUrl: _react2.default.PropTypes.string,
	    disabledJsHint: _react2.default.PropTypes.string,
	    greetingText: _react2.default.PropTypes.string,
	    imageUrl: _react2.default.PropTypes.string,
	    onSignInClick: _react2.default.PropTypes.func
	  }),
	
	  progress: _react2.default.PropTypes.shape({
	    isProgressVisible: _react2.default.PropTypes.bool,
	    onProgressClick: _react2.default.PropTypes.func,
	    percentage: _react2.default.PropTypes.number,
	    isSelected: _react2.default.PropTypes.bool
	  }),
	
	  menu: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object)).isRequired,
	
	  onShowMenu: _react2.default.PropTypes.func,
	  onMenuClicked: _react2.default.PropTypes.func,
	  style: _react2.default.PropTypes.object
	};
	
	Navbar.defaultProps = {
	  progress: {
	    isProgressVisible: false
	  }
	};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  imageSrc: _react2.default.PropTypes.string,
	  url: _react2.default.PropTypes.string,
	  altText: _react2.default.PropTypes.string
	};
	
	var defaultProps = {};
	
	var Logo = function (_React$Component) {
	  _inherits(Logo, _React$Component);
	
	  function Logo() {
	    _classCallCheck(this, Logo);
	
	    return _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).apply(this, arguments));
	  }
	
	  _createClass(Logo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          imageSrc = _props.imageSrc,
	          url = _props.url,
	          altText = _props.altText;
	
	
	      var background = 'transparent url(' + imageSrc + ') no-repeat center center';
	
	      return _react2.default.createElement('a', { href: url, className: _styles2.default.logo, style: { background: background }, title: altText });
	    }
	  }]);
	
	  return Logo;
	}(_react2.default.Component);
	
	exports.default = Logo;
	;
	
	Logo.propTypes = propTypes;
	Logo.defaultProps = defaultProps;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"progressBar":"OQC09ByaKPSUutVIYC1mr","colorOne":"X1Trk3pKA-p09ITXj3grD","colorTwo":"_38MyagaehYQXaUNARgsHvQ","completed":"_17iVqwDhNi6sRcWfXw0Fhz","progressSelected":"_2hWuzCrICPXxafgIqxMfXw","progressUnselected":"FUsYp7-BNy97G1qYSe0-B","completeWrapper":"_3fYN_YXcpgnOs_ufX1bV7X","progressCircle":"_3p8D3peF0oq13gxPnhTIj7","progressCircleBack":"_3oqbawrYNu2XiH6_crNlYD","graduationCapWrapper":"_2ARX99V0vVL9nXyH3-bFo0","graduationCap":"_120UFgvCaMeqUiDyv8Glgg","menuWrapper":"_2nLj3bqZd_vo66uTyxIQir","wrapperSelected":"_2jicTfgjuWdr-JuS2gkN9n","navbar":"IFuN6iWAOFrXxA6mgKpJT","progressVisible":"cFUZfNAOmbUFi_GfSewY-","contentWrapper":"_1QGowjoJ6L0ZzajhIzHME0","logo":"_2bw_gA91e_zIbudgsLkgKL","topMenu":"h55KAB_rxpcS9GBEipyas","topMenuItem":"_2ThbRrQKq6r7Wx42MvAFS0","message":"_3XbXjB8n_qhh_iYv0MgKxL","em":"_2mSnlcHVmyAVjF4fxHJVX0","messageButton":"_2wy2nElAIu4OUTKf6p2akm","profile":"_2q16ZTp3_uy12GSLBfW8mu","arrowIcon":"_3vm2eVFb4-86gqnHCjse9j","hamburgerIcon":"_3ir-ZWL3GtfDNGPh3MCHed","menuToggleDisabledjsHint":"JY9uqGXpPZR2AA6z-axrX","menuItem":"ButMERdr0PSpuJ6lAZ8cT","menuItemSelected":"_1pxyslnWgbemGeqFlRLQ-","menuItemHover":"_3Q4AsCf_l5pydDQ9J43IqH","betaBadge":"_1iQ6KejFCoi9KOSfwyQxmx","sideMenu":"EVUMZKoGf5vN_6MTfaYus","sideMenuResponsive":"_1Yr2iZwRLgQALxP1jujksu","sideMenuActive":"_2FTvkk2uKjfuiBh_4qdtlT","padded":"_3Mu2YSjT-voxd2k38zGDIA","sideMenuItem":"wrV7lkPD64emRZe-vyhLJ","sideMenuSeparator":"_3V_OWSSkx4CNRztVhBB6zv","badge":"_3dxZ65Z14XCKXSlyHc_LgN","signUpFor":"_3HxUutElFJ3GrLuYrwWuFB","hintText":"_2QPQMrKpTOuHG5UwXYQqo8","productIcon":"_2n0ROwgUGj31wWl6sI4Yax","g2tIcon":"_1KgpKKjz5rdX0--w3CjmFv","g2wIcon":"Tma_RwUNPRE_8TIugbbNl","openVoiceIcon":"_10dSYPEwora309HnECX3gD"};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  buttonText: _react2.default.PropTypes.string,
	  messageAction: _react2.default.PropTypes.func,
	  style: _react2.default.PropTypes.object,
	  text: _react2.default.PropTypes.string.isRequired
	};
	
	var defaultProps = {
	  messageAction: function messageAction() {}
	};
	
	var Message = function (_React$Component) {
	  _inherits(Message, _React$Component);
	
	  function Message(props) {
	    _classCallCheck(this, Message);
	
	    return _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).call(this, props));
	  }
	
	  _createClass(Message, [{
	    key: 'render',
	    value: function render() {
	      var button = null;
	      if (this.props.buttonText) {
	        button = _react2.default.createElement(
	          'button',
	          {
	            id: 'navbar-message-button',
	            className: (0, _classnames2.default)(_styles2.default.messageButton, 'btn', 'btn-primary'),
	            onClick: this.props.messageAction
	          },
	          this.props.buttonText
	        );
	      }
	      return _react2.default.createElement(
	        'span',
	        { className: _styles2.default.message },
	        this.props.text,
	        button
	      );
	    }
	  }]);
	
	  return Message;
	}(_react2.default.Component);
	
	exports.default = Message;
	
	
	Message.propTypes = propTypes;
	Message.defaultProps = defaultProps;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MenuItem = __webpack_require__(11);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  menu: _react2.default.PropTypes.array.isRequired
	};
	
	var TopMenu = function (_React$Component) {
	  _inherits(TopMenu, _React$Component);
	
	  function TopMenu() {
	    _classCallCheck(this, TopMenu);
	
	    return _possibleConstructorReturn(this, (TopMenu.__proto__ || Object.getPrototypeOf(TopMenu)).apply(this, arguments));
	  }
	
	  _createClass(TopMenu, [{
	    key: 'render',
	    value: function render() {
	      var items = this.props.menu.map(function (item, index) {
	        return _react2.default.createElement(
	          'li',
	          { className: _styles2.default.topMenuItem, key: index },
	          _react2.default.createElement(
	            _MenuItem2.default,
	            item,
	            item.text
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        'ul',
	        { className: _styles2.default.topMenu },
	        items
	      );
	    }
	  }]);
	
	  return TopMenu;
	}(_react2.default.Component);
	
	exports.default = TopMenu;
	
	
	TopMenu.propTypes = propTypes;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _react2.default.PropTypes.node,
	  id: _react2.default.PropTypes.string,
	  isBeta: _react2.default.PropTypes.bool,
	  isSelected: _react2.default.PropTypes.bool,
	  onClick: _react2.default.PropTypes.func,
	  style: _react2.default.PropTypes.object,
	  url: _react2.default.PropTypes.string
	};
	
	var defaultProps = {
	  iconClasses: ''
	};
	
	var MenuItem = function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  function MenuItem(props) {
	    _classCallCheck(this, MenuItem);
	
	    var _this = _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call(this, props));
	
	    _this.state = { isHover: false };
	    return _this;
	  }
	
	  _createClass(MenuItem, [{
	    key: 'onMouseOver',
	    value: function onMouseOver() {
	      this.setState({ isHover: true });
	    }
	  }, {
	    key: 'onMouseOut',
	    value: function onMouseOut() {
	      this.setState({ isHover: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var classNames = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, _styles2.default.menuItem, true), _defineProperty(_classnames, _styles2.default.menuItemSelected, this.props.isSelected), _defineProperty(_classnames, _styles2.default.menuItemHover, this.state.isHover), _classnames));
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'a',
	          {
	            href: this.props.url,
	            onMouseOver: this.onMouseOver.bind(this),
	            onMouseOut: this.onMouseOut.bind(this),
	            onClick: this.props.onClick,
	            className: classNames,
	            style: this.props.style,
	            id: this.props.id
	          },
	          this.props.children,
	          this.props.isBeta && _react2.default.createElement('img', { src: '//cdn.gotomeet.at/images/beta-badge.png', className: _styles2.default.betaBadge })
	        )
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(_react2.default.Component);
	
	exports.default = MenuItem;
	
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Profile = function (_React$Component) {
	  _inherits(Profile, _React$Component);
	
	  function Profile() {
	    _classCallCheck(this, Profile);
	
	    return _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
	  }
	
	  _createClass(Profile, [{
	    key: 'render',
	    value: function render() {
	      var disabledJsHint = this.props.disabledJsHint ? _react2.default.createElement('noscript', {
	        dangerouslySetInnerHTML: { __html: '<div\n                class="' + _styles2.default.menuToggleDisabledjsHint + ' menu-toggle-disabledjs-hint">\n                      ' + this.props.disabledJsHint + '\n                    </div>' }
	      }) : '';
	
	      return _react2.default.createElement(
	        'a',
	        {
	          href: 'javascript:void(0)',
	          onClick: this.props.onClick,
	          className: (0, _classnames2.default)(_styles2.default.profile, 'menu-toggle')
	        },
	        disabledJsHint,
	        this.props.text,
	        _react2.default.createElement('i', { className: (0, _classnames2.default)('togo-icon', 'togo-icon-down-arrow', _styles2.default.arrowIcon) })
	      );
	    }
	  }]);
	
	  return Profile;
	}(_react2.default.Component);
	
	exports.default = Profile;
	
	
	Profile.propTypes = {
	  onClick: _react2.default.PropTypes.func,
	  text: _react2.default.PropTypes.string,
	  disabledJsHint: _react2.default.PropTypes.string
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileMobile = function (_React$Component) {
	  _inherits(ProfileMobile, _React$Component);
	
	  function ProfileMobile() {
	    _classCallCheck(this, ProfileMobile);
	
	    return _possibleConstructorReturn(this, (ProfileMobile.__proto__ || Object.getPrototypeOf(ProfileMobile)).apply(this, arguments));
	  }
	
	  _createClass(ProfileMobile, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'a',
	        {
	          href: 'javascript:void(0)',
	          onClick: this.props.onClick,
	          className: _styles2.default.profile
	        },
	        _react2.default.createElement('i', { className: (0, _classnames2.default)('togo-icon', 'togo-icon-hamburger', _styles2.default.hamburgerIcon) })
	      );
	    }
	  }]);
	
	  return ProfileMobile;
	}(_react2.default.Component);
	
	exports.default = ProfileMobile;
	
	
	ProfileMobile.propTypes = {
	  onClick: _react2.default.PropTypes.func
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignInLink = function (_React$Component) {
	  _inherits(SignInLink, _React$Component);
	
	  function SignInLink() {
	    _classCallCheck(this, SignInLink);
	
	    return _possibleConstructorReturn(this, (SignInLink.__proto__ || Object.getPrototypeOf(SignInLink)).apply(this, arguments));
	  }
	
	  _createClass(SignInLink, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'a',
	        {
	          href: this.props.url,
	          className: _styles2.default.profile,
	          onClick: this.props.onClick
	        },
	        this.props.text
	      );
	    }
	  }]);
	
	  return SignInLink;
	}(_react2.default.Component);
	
	exports.default = SignInLink;
	
	
	SignInLink.propTypes = {
	  text: _react2.default.PropTypes.string.isRequired,
	  url: _react2.default.PropTypes.string.isRequired,
	  onClick: _react2.default.PropTypes.func
	};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Item = __webpack_require__(16);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _Separator = __webpack_require__(17);
	
	var _Separator2 = _interopRequireDefault(_Separator);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  // Toggle to display the component
	  // Always keep this component in the DOM for animiation support.
	  isActive: _react2.default.PropTypes.bool.isRequired,
	
	  // Toggle for mobile styles
	  isSmallScreen: _react2.default.PropTypes.bool,
	
	  isProgressVisible: _react2.default.PropTypes.bool,
	
	  // Array of arrays of menu items
	  // Each array represents a menu group divided by a separator
	  itemGroups: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.array)
	};
	
	var SideMenu = function (_React$Component) {
	  _inherits(SideMenu, _React$Component);
	
	  function SideMenu() {
	    _classCallCheck(this, SideMenu);
	
	    return _possibleConstructorReturn(this, (SideMenu.__proto__ || Object.getPrototypeOf(SideMenu)).apply(this, arguments));
	  }
	
	  _createClass(SideMenu, [{
	    key: 'renderItems',
	    value: function renderItems() {
	      var elements = [];
	
	      this.props.itemGroups.forEach(function (itemGroup, itemGroupIndex, itemGroups) {
	        itemGroup.forEach(function (item, itemIndex) {
	          elements.push(_react2.default.createElement(_Item2.default, _extends({
	            key: itemGroupIndex + '-' + itemIndex
	          }, item)));
	        });
	
	        if (itemGroupIndex < itemGroups.length - 1) {
	          elements.push(_react2.default.createElement(
	            'li',
	            { key: itemGroupIndex + '-divider' },
	            _react2.default.createElement(_Separator2.default, null)
	          ));
	        }
	      });
	
	      return elements;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var classNames = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, _styles2.default.sideMenu, true), _defineProperty(_classnames, _styles2.default.sideMenuResponsive, this.props.isSmallScreen), _defineProperty(_classnames, _styles2.default.sideMenuActive, this.props.isActive), _defineProperty(_classnames, _styles2.default.padded, this.props.isProgressVisible), _defineProperty(_classnames, 'side-bar-menu', true), _classnames));
	
	      return _react2.default.createElement(
	        'ul',
	        {
	          className: classNames,
	          onClick: function onClick(event) {
	            return event.stopPropagation();
	          }
	        },
	        this.renderItems()
	      );
	    }
	  }]);
	
	  return SideMenu;
	}(_react2.default.Component);
	
	exports.default = SideMenu;
	
	
	SideMenu.propTypes = propTypes;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MenuItem = __webpack_require__(11);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Item = function (_React$Component) {
	  _inherits(Item, _React$Component);
	
	  function Item() {
	    _classCallCheck(this, Item);
	
	    return _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
	  }
	
	  _createClass(Item, [{
	    key: 'render',
	    value: function render() {
	      var itemElement = this.props.text || this.props.reactElement;
	
	      if (this.props.customHtml) {
	        itemElement = _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.customHtml } });
	      }
	
	      return _react2.default.createElement(
	        'li',
	        { className: _styles2.default.sideMenuItem },
	        _react2.default.createElement(
	          _MenuItem2.default,
	          this.props,
	          itemElement
	        )
	      );
	    }
	  }]);
	
	  return Item;
	}(_react2.default.Component);
	
	exports.default = Item;
	
	
	Item.propTypes = {
	  customHtml: _react2.default.PropTypes.string,
	  reactElement: _react2.default.PropTypes.element,
	  style: _react2.default.PropTypes.object,
	  text: _react2.default.PropTypes.string,
	  url: _react2.default.PropTypes.string
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Separator = function (_React$Component) {
	  _inherits(Separator, _React$Component);
	
	  function Separator() {
	    _classCallCheck(this, Separator);
	
	    return _possibleConstructorReturn(this, (Separator.__proto__ || Object.getPrototypeOf(Separator)).apply(this, arguments));
	  }
	
	  _createClass(Separator, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('hr', { className: _styles2.default.sideMenuSeparator });
	    }
	  }]);
	
	  return Separator;
	}(_react2.default.Component);
	
	exports.default = Separator;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames3 = __webpack_require__(3);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _ProgressBar = __webpack_require__(19);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  onProgressClick: _react2.default.PropTypes.func,
	  percentage: _react2.default.PropTypes.number.isRequired,
	  isSelected: _react2.default.PropTypes.bool
	};
	
	var ProgressBar = function (_React$Component) {
	  _inherits(ProgressBar, _React$Component);
	
	  function ProgressBar(props) {
	    _classCallCheck(this, ProgressBar);
	
	    return _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this, props));
	  }
	
	  _createClass(ProgressBar, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var strokeDashoffset = parseInt(127.5 - this.props.percentage * 1.275);
	      var style = {
	        progressCircle: {
	          strokeDashoffset: strokeDashoffset
	        }
	      };
	
	      var getProgress = function getProgress() {
	        if (_this2.props.percentage === 100) {
	          return _react2.default.createElement(
	            'div',
	            { className: _ProgressBar2.default.completeWrapper },
	            _react2.default.createElement('i', { className: (0, _classnames4.default)(_ProgressBar2.default.completed, 'togo-icon', 'togo-icon-check') })
	          );
	        } else {
	          var _classnames, _classnames2;
	
	          var classNames = (0, _classnames4.default)((_classnames = {}, _defineProperty(_classnames, _ProgressBar2.default.progressCircleBack, true), _defineProperty(_classnames, _ProgressBar2.default.progressSelected, _this2.props.isSelected), _defineProperty(_classnames, _ProgressBar2.default.progressUnselected, !_this2.props.isSelected), _classnames));
	          var classMenuWrapper = (0, _classnames4.default)((_classnames2 = {}, _defineProperty(_classnames2, _ProgressBar2.default.menuWrapper, true), _defineProperty(_classnames2, _ProgressBar2.default.wrapperSelected, _this2.props.isSelected), _classnames2));
	          return _react2.default.createElement(
	            'div',
	            { id: 'menu-gsu', className: classMenuWrapper },
	            _react2.default.createElement(
	              'div',
	              { className: _ProgressBar2.default.graduationCapWrapper },
	              _react2.default.createElement('img', {
	                className: _ProgressBar2.default.graduationCap,
	                src: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/170551/icon-graduation.svg'
	              })
	            ),
	            _react2.default.createElement(
	              'svg',
	              { version: '1.1', width: '60px', height: '60px' },
	              _react2.default.createElement(
	                'linearGradient',
	                { id: 'progressFill' },
	                _react2.default.createElement('stop', { offset: '0', className: _ProgressBar2.default.colorOne }),
	                _react2.default.createElement('stop', { offset: '1', className: _ProgressBar2.default.colorTwo })
	              ),
	              _react2.default.createElement('circle', { r: '20', cx: '30', cy: '30',
	                className: classNames }),
	              _react2.default.createElement('circle', { r: '20', cx: '30', cy: '30',
	                className: _ProgressBar2.default.progressCircle,
	                style: style.progressCircle,
	                transform: 'rotate(-90 30 30)' })
	            )
	          );
	        }
	      };
	
	      return _react2.default.createElement(
	        'span',
	        { className: _ProgressBar2.default.progressBar, onClick: this.props.onProgressClick },
	        getProgress()
	      );
	    }
	  }]);
	
	  return ProgressBar;
	}(_react2.default.Component);
	
	exports.default = ProgressBar;
	
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = {
	  onProgressClick: function onProgressClick() {},
	  percentage: 0
	};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"progressBar":"V_98yHYA94EUfc13l596o","colorOne":"eLp9g7MyM6JV7mZBMgCg1","colorTwo":"LR1i_Lvn-lTVayuAq8z3Z","completed":"_3PNxWI46GhIKUSvcrRaLCN","progressSelected":"_2vxv1pt8DUgzO8bBGMA_qp","progressUnselected":"_1V50m5m_u2fRNpRbBOtVY4","completeWrapper":"_1RLSHvODhG_wOZ-rw2kbSj","progressCircle":"_1V0cQBWP4hc7uLZBoanhSe","progressCircleBack":"_1a9xmzP9LMInlwvobTnB9I","graduationCapWrapper":"_3xCCRGKhLHfdLekxuN9ou7","graduationCap":"_3NORR4BfGmXMBy81C-qxNy","menuWrapper":"_2r4N9thDXAndyVMaaNw1Z1","wrapperSelected":"_3kjEt2yDwi6L_9nSVIxeea"};

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _logo = __webpack_require__(22);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _profile = __webpack_require__(23);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _message = __webpack_require__(24);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _menu = __webpack_require__(26);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * creates components using the parameters passed in.
	 * @param {object} config - configuration values that help set up navbar
	 * {
	 *     locale: {string},
	 *     hasG2mmProfile: {bool},
	 *     currentMenuItem: {string},
	 *     isVoicePlan: {bool},
	 *     showBeta: {bool},
	 *     showLabs: {bool},
	 *     isBillingAdmin: {bool},
	 *     expiringTrial: {bool},
	 *     isAuthenticated: {bool},
	 *     authorization: {string}',
	 *     messageAction: {function}
	 *     user: {obj}
	 *   }
	 * @param {object} urls - url object that function to get urls to be used for navigation {get: fn()}
	 * @param {function} translate - translation function that helps localization
	 * @param {object} tracking - tracking related function can be passed in as object {tracking: fn()}
	 *
	 */
	
	exports.default = function (config, urls, translate, tracking) {
	  var logo = (0, _logo2.default)(config, urls);
	  var profile = (0, _profile2.default)(config, urls, translate, tracking);
	  var message = (0, _message2.default)(config, translate);
	  var menu = (0, _menu2.default)(config, urls, translate, tracking);
	  var onShowMenu = function onShowMenu() {
	    return tracking.track('Clicked to see menu');
	  };
	  var progress = config.progress;
	  var onMenuClicked = config.onMenuClicked;
	  return { logo: logo, profile: profile, message: message, menu: menu, onShowMenu: onShowMenu, progress: progress, onMenuClicked: onMenuClicked };
	};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (config, urls) {
	  var imageSrc = '//cdn.gotomeet.at/images/web-portal/g2mlogo-white.svg';
	  var meetingFrontendUrl = urls.get('meetingFrontendHost') || urls.get('meetingFrontEndSvcUrl');
	
	  var url = void 0;
	  if (config.restrictNavigation) {
	    url = 'javascript: window.location.reload()';
	  } else if (config.isAuthenticated) {
	    url = meetingFrontendUrl + '/#';
	  } else {
	    url = urls.get('g2mLanding');
	  }
	
	  return { imageSrc: imageSrc, url: url };
	};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (config, urls, translate, tracking) {
	  if (config.restrictNavigation) {
	    // Workaround to make the menu disappear
	    // Set "signed in" to false, which will make the sign in text appear
	    // Set the "sign in text" to a blank string, displaying nothing
	    return {
	      isSignedIn: false,
	      signInText: ''
	    };
	  }
	
	  return {
	    isSignedIn: config.isAuthenticated,
	    signInText: translate('common.signIn'),
	    signInUrl: urls.get('logIn'),
	    disabledJsHint: translate('hints.disabledJsHint'),
	    name: config.user ? config.user.firstName + ' ' + config.user.lastName : '',
	    onSignInClick: function onSignInClick() {
	      return tracking.trackLink(urls.get('logIn'), 'Click Sign In - Menu Bar');
	    }
	  };
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(25);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (config, translate) {
	  var getTrialExpiryMessage = function getTrialExpiryMessage(trialDaysLeft) {
	    if (trialDaysLeft <= 1) {
	      return translate('trial.expires.today.withNoMeetingsForOrganizer');
	    } else {
	      return translate('trial.expires.lessThan5DaysLeft.withNoMeetingsForOrganizer', trialDaysLeft);
	    }
	  };
	
	  var text = '';
	  var shouldShowMessage = !config.restrictNavigation && config.expiringTrial;
	
	  if (!shouldShowMessage) {
	    return { text: text };
	  }
	
	  var trialDaysLeft = (0, _moment2.default)(config.expiringTrial.endDate).diff((0, _moment2.default)(), 'days');
	  text = getTrialExpiryMessage(trialDaysLeft);
	  var buttonText = config.isBillingAdmin ? translate('trial.expires.buy') : translate('trial.expires.learn');
	
	  return { text: text, messageAction: config.messageAction, buttonText: buttonText };
	};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_25__;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Badge = __webpack_require__(27);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	var _Signup = __webpack_require__(28);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _Product = __webpack_require__(29);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var meetingFrontendUrl = void 0;
	var insightsUrl = void 0;
	
	var createMenuItem = function createMenuItem(text, url, options) {
	  var menuItem = _extends({ url: url }, options);
	
	  if (_react2.default.isValidElement(text)) {
	    menuItem.reactElement = text;
	  } else if (text[0] === '<') {
	    menuItem.customHtml = text;
	  } else {
	    menuItem.text = text;
	  }
	
	  return menuItem;
	};
	
	var addMenuItems = function addMenuItems(config, urls, translate) {
	  var menuItemArray = [createMenuItem(translate('myMeetings.selection.upcoming') || 'My Meetings', meetingFrontendUrl + '#meetings', {
	    isTopMenuItem: true,
	    isSelected: config.currentMenuItem === '#meetings' || config.currentMenuItem === '#',
	    id: 'meetings'
	  }), createMenuItem(translate('links.g2m.audiosettings') || 'Settings', meetingFrontendUrl + '#settings', {
	    isTopMenuItem: true,
	    isSelected: config.currentMenuItem === '#settings',
	    id: 'menu-settings'
	  })];
	
	  if (config.setSaleProvisioned) {
	    menuItemArray.splice(1, 0, createMenuItem(translate('settings.setSale.navbarTitle') || 'Insights', '' + insightsUrl, {
	      isBeta: true,
	      isTopMenuItem: true,
	      isSelected: config.currentMenuItem === '#analytics' || config.currentMenuItem === '#insights',
	      id: 'menu-analytics'
	    }));
	  }
	
	  return menuItemArray;
	};
	
	var topMenuItems = function topMenuItems(config, urls, translate) {
	  return !config.isAuthenticated ? [] : addMenuItems(config, urls, translate);
	};
	
	var isAdmin = function isAdmin(authorization) {
	  return authorization.indexOf('ROLE_EXT_ADMIN') !== -1;
	};
	
	var sideBarItems = function sideBarItems(config, urls, translate, tracking) {
	  var all = [];
	  var next = [];
	
	  var authorization = config.authorization || [];
	
	  var myAccountText = translate('links.g2m.myaccount') || 'My Account';
	  var adminCenterText = translate('links.g2m.extAdmin') || 'Admin Center';
	
	  var isAdminUser = isAdmin(authorization);
	
	  var upgradeBadge = _react2.default.createElement(_Badge2.default, {
	    title: myAccountText,
	    badge: translate('links.g2m.upgrade') || 'Upgrade',
	    badgeLink: urls.get('myaccountUrl')
	  });
	
	  var subscribeBadge = _react2.default.createElement(_Badge2.default, {
	    title: myAccountText,
	    badge: translate('links.g2m.subscribe') || 'Subscribe',
	    badgeLink: urls.get('myaccountUrl')
	  });
	
	  var addUserBadge = _react2.default.createElement(_Badge2.default, {
	    title: adminCenterText,
	    badge: translate('links.g2m.addusers') || 'Add Users',
	    badgeLink: urls.get('adminUrl')
	  });
	  var myAccountBadge = '';
	  var adminCenterBadge = '';
	
	  if (config.isVoicePlan) {
	    if (isAdminUser) {
	      myAccountBadge = config.isBillingAdmin ? upgradeBadge : '';
	      adminCenterBadge = config.isBillingAdmin ? '' : addUserBadge;
	    }
	  } else if (config.expiringTrial) {
	    if (isAdminUser) {
	      myAccountBadge = config.isBillingAdmin ? subscribeBadge : '';
	      adminCenterBadge = config.isBillingAdmin ? '' : addUserBadge;
	    }
	  } else {
	    // all other plans
	    if (isAdminUser) {
	      adminCenterBadge = addUserBadge;
	    }
	  }
	
	  var myAccountEl = isAdminUser && myAccountBadge ? myAccountBadge : myAccountText;
	  var adminCenterEl = adminCenterBadge || adminCenterText;
	
	  next.push(createMenuItem(myAccountEl, urls.get('myaccountUrl'), {
	    id: 'account',
	    onClick: function onClick() {
	      return tracking.trackLink(urls.get('myaccountUrl'), 'Click My Account Link - Menu Bar');
	    }
	  }));
	
	  if (isAdminUser) {
	    next.push(createMenuItem(adminCenterEl, urls.get('adminUrl'), {
	      id: 'admincenter',
	      onClick: function onClick() {
	        return tracking.trackLink(urls.get('adminUrl'), 'Click Admin Center Link - Menu Bar');
	      }
	    }));
	  }
	
	  if (config.locale && config.locale.indexOf('en') > -1 && (config.showBeta || config.showLabs)) {
	    // If user account has voice plan (or) does not have a G2MM profile: Link to #labs since #beta is disabled.
	    var linkHash = config.isVoicePlan || !config.hasG2mmProfile ? meetingFrontendUrl + '#labs' : meetingFrontendUrl + '#beta';
	
	    next.push(createMenuItem(translate('links.g2m.labs') || 'Betas and labs', linkHash, {
	      isSelected: config.currentMenuItem === '#labs' || config.currentMenuItem === '#beta',
	      id: 'labslink'
	    }));
	  }
	
	  next.push(createMenuItem(translate('links.g2m.support') || 'Support', translate('web-urls.urls.g2m.support'), { id: 'support' }));
	
	  if (!config.isVoicePlan && config.locale && (config.locale.indexOf('en') > -1 || config.locale.indexOf('de') > -1)) {
	    var signUpForText = (translate('links.g2m.producttraining') || 'Sign up for<br>Training').split('<br>');
	
	    var element = _react2.default.createElement(_Signup2.default, {
	      name: signUpForText[0] || 'Sign Up For',
	      hintText: signUpForText[1].replace(/%s/gi, '')
	    });
	
	    next.push(createMenuItem(element, translate('web-urls.urls.gototraining.public'), {
	      style: {
	        marginTop: 25,
	        marginBottom: 0,
	        fontSize: 12
	      },
	      id: 'training-link',
	      onClick: function onClick() {
	        return tracking.trackLink(translate('web-urls.urls.gototraining.public'), 'Navigate to Product Training - Menu Bar');
	      }
	    }));
	  }
	
	  all.push(next);
	
	  // products
	  next = [];
	  if (authorization.indexOf('ROLE_G2T_ORGANIZER') !== -1) {
	    var _element = _react2.default.createElement(_Product2.default, {
	      classes: [_styles2.default.g2tIcon],
	      name: 'GoToTraining'
	    });
	
	    next.push(createMenuItem(_element, urls.get('g2tUrl'), {
	      onClick: function onClick() {
	        return tracking.trackLink(urls.get('g2tUrl'), 'GoToTraining Link');
	      },
	      id: 'gototraining'
	    }));
	  }
	
	  if (authorization.indexOf('ROLE_G2W_ORGANIZER') !== -1) {
	    var _element2 = _react2.default.createElement(_Product2.default, {
	      classes: [_styles2.default.g2wIcon],
	      name: 'GoToWebinar'
	    });
	
	    next.push(createMenuItem(_element2, urls.get('g2wUrl'), {
	      onClick: function onClick() {
	        return tracking.trackLink(urls.get('g2wUrl'), 'GoToWebinar Link');
	      },
	      id: 'gotowebinar'
	    }));
	  }
	
	  if (authorization.indexOf('ROLE_OPENVOICE_ORGANIZER') !== -1) {
	    var _element3 = _react2.default.createElement(_Product2.default, {
	      classes: [_styles2.default.openVoiceIcon],
	      name: 'OpenVoice'
	    });
	
	    next.push(createMenuItem(_element3, urls.get('ovUrl'), {
	      onClick: function onClick() {
	        return tracking.trackLink(urls.get('ovUrl'), 'OpenVoice Link');
	      },
	      id: 'openvoice'
	    }));
	  }
	
	  if (next.length) {
	    all.push(next);
	  }
	
	  next = [];
	
	  // sign out is on a section on its own
	  next.push(createMenuItem(translate('links.signout') || 'Sign Out', urls.get('logOut') || '/j_spring_security_logout', {
	    onClick: function onClick(e) {
	      config.signoutCallback && config.signoutCallback(e);
	    },
	    id: 'sign-out'
	  }));
	
	  all.push(next);
	
	  return all;
	};
	
	exports.default = function (config, urls, translate, tracking) {
	  meetingFrontendUrl = urls.get('meetingFrontendHost') || urls.get('meetingFrontEndSvcUrl');
	  insightsUrl = urls.get('setsaleUrl');
	
	  if (config.restrictNavigation) {
	    // Do not display menu items
	    return [];
	  }
	
	  var sideItems = sideBarItems(config, urls, translate, tracking);
	  var allItems = [topMenuItems(config, urls, translate).concat(sideItems[0])];
	
	  if (sideItems.length > 1) {
	    [].push.apply(allItems, sideItems.slice(1));
	  }
	
	  return allItems;
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  title: _react2.default.PropTypes.string,
	  badge: _react2.default.PropTypes.string,
	  badgeLink: _react2.default.PropTypes.string
	};
	
	var Badge = function (_React$Component) {
	  _inherits(Badge, _React$Component);
	
	  function Badge() {
	    _classCallCheck(this, Badge);
	
	    return _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).apply(this, arguments));
	  }
	
	  _createClass(Badge, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          badgeLink = _props.badgeLink,
	          badge = _props.badge;
	
	
	      var badgeElement = void 0;
	      if (badge) {
	        badgeElement = _react2.default.createElement(
	          'span',
	          { className: _styles2.default.badge, href: badgeLink },
	          badge
	        );
	      }
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        title,
	        badgeElement
	      );
	    }
	  }]);
	
	  return Badge;
	}(_react2.default.Component);
	
	exports.default = Badge;
	
	
	Badge.propTypes = propTypes;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  name: _react2.default.PropTypes.string,
	  hintText: _react2.default.PropTypes.string
	};
	
	var Signup = function (_React$Component) {
	  _inherits(Signup, _React$Component);
	
	  function Signup() {
	    _classCallCheck(this, Signup);
	
	    return _possibleConstructorReturn(this, (Signup.__proto__ || Object.getPrototypeOf(Signup)).apply(this, arguments));
	  }
	
	  _createClass(Signup, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: _styles2.default.signUpFor },
	          this.props.name
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: (0, _classnames2.default)(_styles2.default.signUpFor, _styles2.default.hintText) },
	          this.props.hintText
	        )
	      );
	    }
	  }]);
	
	  return Signup;
	}(_react2.default.Component);
	
	exports.default = Signup;
	
	
	Signup.propTypes = propTypes;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(5);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  classes: _react2.default.PropTypes.array.isRequired,
	  name: _react2.default.PropTypes.string
	};
	
	var Product = function (_React$Component) {
	  _inherits(Product, _React$Component);
	
	  function Product() {
	    _classCallCheck(this, Product);
	
	    return _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).apply(this, arguments));
	  }
	
	  _createClass(Product, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          classes = _props.classes;
	
	
	      classes.unshift('togo-icon', 'togo-icon-gotomeeting', _styles2.default.productIcon);
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('i', { className: (0, _classnames2.default)(classes) }),
	        name
	      );
	    }
	  }]);
	
	  return Product;
	}(_react2.default.Component);
	
	exports.default = Product;
	
	
	Product.propTypes = propTypes;

/***/ })
/******/ ])
});
;
//# sourceMappingURL=navbar.js.map;
